import { useApiWrapper } from '../../../shared/hooks/useApi/apiWrapper';
import {
  getAdminDailyAnalytics,
  getAdminOwnerDailyAnalytics,
} from '../api/adminAnalyticsApi';
import { useAdminAnalyticsStore } from '../store/adminAnalyticsStore';

interface UseAdminAnalyticsResult {
  loadExternalDaily: (from: string, to: string) => Promise<void>;
  loadOwnerDaily: (from: string, to: string) => Promise<void>;
}

export const useAdminAnalytics = (): UseAdminAnalyticsResult => {
  const withApiHandler = useApiWrapper();
  const setExternalData = useAdminAnalyticsStore(
    (state) => state.setExternalData,
  );
  const setOwnerData = useAdminAnalyticsStore((state) => state.setOwnerData);

  const loadExternalDaily = async (
    from: string,
    to: string,
  ): Promise<void> => {
    const response = await withApiHandler(
      () => getAdminDailyAnalytics(from, to),
      [],
    );
    if (response) {
      setExternalData(response.data);
    }
  };

  const loadOwnerDaily = async (from: string, to: string): Promise<void> => {
    const response = await withApiHandler(
      () => getAdminOwnerDailyAnalytics(from, to),
      [],
    );
    if (response) {
      setOwnerData(response.data);
    }
  };

  return { loadExternalDaily, loadOwnerDaily };
};
